import React from 'react';

import { ReactComponent as RmtgLogo } from '../images/remeeting-logo-blue-gray.svg';

const SegmentHeader = () => {
  const { origin } = window.location;
  return (
    <div
      className="re is-header is-flex is-justifyContent-center is-alignItems-center"
    >
      <a href={origin} aria-label="Remeeting logo"><RmtgLogo /></a>
    </div>
  );
};

export default SegmentHeader;
